export default {
  logo: require('@/assets/logo.png'),
  avatar: require('@/assets/images/user/avatar.png'),
  czflBg: require('@/assets/images/home/bg.png'),
  staffBg: require('@/assets/images/home/bg.png'),
  helpBg: require('@/assets/images/home/bg.png'),
  wechatUnbindTips: '解绑提示',
  exchangeTips: '1.每日积分只能兑换一次，可在成长福利查看详情。</br>2.兑换成功后前往游戏邮件领取福利，3-5分钟到账。</br>3.如游戏领取不到充值请联系专属客服。',
  giftTips: '1.游戏大礼包每日可兑换一次，24点后重置</br>2.兑换成功后请在游戏等待3-5分钟后领取</br>3.如领取不到礼包请联系专属客服',
  rechargeTips: '充钱了'
}
